export function buildEprintQrUrl(opts: {
  endpoint: string
  contentsCode: string
  cacheBuster: number
  isPrePayment: boolean
  selectedStore: string | null
}): string {
  const { endpoint, contentsCode, cacheBuster, isPrePayment, selectedStore } =
    opts
  if (isPrePayment) {
    return `${endpoint}${contentsCode}.png?path=p&_=${cacheBuster}`
  }
  if (selectedStore === 'seven') {
    return `${endpoint}${contentsCode}.png?path=f&_=${cacheBuster}`
  }
  if (selectedStore === 'others') {
    return `${endpoint}${contentsCode}.png?_=${cacheBuster}`
  }
  return '/static/img/eprint/sample.png'
}
